<template>
  <a-tree-select
    :disabled="disabled"
    v-model="internalValue"
    :placeholder="placeholder"
    style="width: 100%"
    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    :tree-data="department_tree"
    tree-default-expand-all
    :replaceFields="{
      label: 'department_name',
      children: 'children',
      value: 'department_id',
      key: 'department_id',
    }"
    @change="handleChange"
    :allowClear="allowClear"
  >
  </a-tree-select>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: "请选择所属部门" },
    value: String,
    allowClear: {
      type: Boolean,
      default: false,
    },
    needFirst: { type: Boolean, default: false },
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue || undefined;
    },
  },
  data() {
    return {
      loading: false,
      department_tree: [],
      internalValue: undefined,
    };
  },
  mounted() {
    this.getTree();
  },
  methods: {
    //获取公司（部门）列表
    getTree() {
      this.loading = true;
      this.$http({
        method: "get",
        url: `/admin/department/page`,
      })
        .then((res) => {
          if (res.data.length > 0) {
            this.department_tree = [...res.data];
          }
          this.$emit("getDataSuccess", res.data);
        })
        .finally(() => (this.loading = false));
    },
    handleChange(e) {
      this.$emit("change", e === undefined ? "" : e);
    },
    filter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
  },
};
</script>

<style>
</style>